import DocumentResourcePagingResultModel from '../../generated/types/model/resource/DocumentResourcePagingResultModel';

export default class DocumentResourcePagingResultViewModel extends DocumentResourcePagingResultModel {
  // For instructions on how to use ViewModels visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
